import { SELECTORS as DRAWER_SELECTORS } from "./drawer";

const SELECTOR = `${DRAWER_SELECTORS.main}--panel--search`

export default class SearchButton {
    #onOpen = null
    #onClose = null

    #context = null
    #element = null

    constructor(context, { onOpen, onClose } = {}) {
        this.#context = context
        this.#element = this.#context.getElementBySelector(SELECTOR)

        this.#context.registerNewElement('search', this.#element)

        if (onClose && typeof onClose === 'function') {
            this.#onClose = onClose
        }

        if (onOpen && typeof onOpen === 'function') {
            this.#onOpen = onOpen
        }
    }

    close = () => {
        this.#element.style.display = 'none'
        this.#onClose?.()
    }

    open = () => {
        this.#element.style.display = 'block'
        this.#onOpen?.()
    }
}